import React, { Component, Fragment } from 'react'
import Breadcrumbs from '../../shared/Breadcrumbs'
import { FieldsRoute } from '../../routing'

export class FieldsPage extends Component {
    render() {
        return (
            <Fragment>
            <Breadcrumbs />
            <FieldsRoute />
          </Fragment>
        )
    }
}
